export default __webpack_public_path__ + "static/media/cleanCircle.e54d91ce.png";